import React from 'react';
import { createMaskedInput } from './MaskedInput';
import { AdornedInput, Adornment } from '@zillow/constellation';
import { getNumberFromString } from '../../utils/formatters';

function removeDollarSign(value: string) {
  return value.replace('$', '');
}

function addDollarSign(value: string) {
  value = removeDollarSign(value).trim();
  if (!value) return '';
  return `$${value}`;
}

const MaskedCurrencyInputNotAdorned = createMaskedInput(
  {
    mask: 'num',
    blocks: {
      num: {
        mask: Number,
        thousandsSeparator: ',',
        radix: '.',
        scale: 2,
        padFractionalZeros: true,
        normalizeZeros: true,
      },
    },
    type: 'text',
    inputMode: 'numeric',
  },
  removeDollarSign,
  addDollarSign,
);

export const MaskedCurrencyInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<typeof MaskedCurrencyInputNotAdorned>
>(function MaskedCurrencyInput(props, ref) {
  return (
    <AdornedInput
      leftAdornment={<Adornment>$</Adornment>}
      input={<MaskedCurrencyInputNotAdorned ref={ref} {...props} />}
      rightAdornment={<Adornment>/month</Adornment>}
    />
  );
});

export const validateCurrency = (value: string) => {
  if (getNumberFromString(value) <= 0) {
    return 'Amount must be greater than $0.00';
  }
  return true;
};
